import { Command } from '@ckeditor/ckeditor5-core'

export default class InsertTagsCommand extends Command {
    execute({ value }) {
        this.editor.model.change(writer => {
            this.editor.model.insertObject(createTags(writer, value))
        })
    }

    refresh() {
        const model = this.editor.model
        const selection = model.document.selection
        const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'tags')

        this.isEnabled = allowedIn !== null
    }
}

function createTags(writer, value) {
    const tags = writer.createElement('tags', {
        tag: value
    })
    const tagsInner = writer.createElement('tagsInner', {
        tag: value
    })
    const tagsData = writer.createElement('tagsData', {
        tag: value
    })
    const tagsTitle = writer.createElement('tagsTitle',  {
        tag: value
    })
    const tagsContent = writer.createElement('tagsContent')

    writer.append(tagsInner, tags)
    writer.append(tagsData, tagsInner)
    writer.append(tagsTitle, tagsInner)
    writer.append(tagsContent, tagsInner)

    writer.appendElement('paragraph', tagsContent)

    return tags
}